import { formatDateToLocale } from '../../../../services/util/date.service'

const DATE_FORMAT = 'dd/MM/yy HH:mm:ss'

function _formatItemValue(item) {
  if (item.value && item.value !== '-') {
    try {
      return { ...item, value: formatDateToLocale(item.value, DATE_FORMAT).toFormat(DATE_FORMAT) }
    } catch (e) {
      return { ...item, value: '-' }
    }
  }
  return { ...item, value: '-' }
}

export function normalizeCardInfosTimezone(infos) {
  return (infos || []).map(card => {
    if (card.title === 'Horários') {
      return { ...card, items: card.items.map(_formatItemValue) }
    }
    // No card 'Maior Intervalo' apenas o items[0] é data; o items[1] é uma duração (HH:mm:ss)
    if (card.title === 'Maior Intervalo' && card.items[0]) {
      return {
        ...card,
        items: card.items.map((item, index) => (index === 0 ? _formatItemValue(item) : item)),
      }
    }
    return card
  })
}

export function consolidarProdutos(produtos, { consolidarLoteValidade, pickingStyle }) {
  if (pickingStyle === 'Reconferencia' || !consolidarLoteValidade) {
    // Consolidar somente por product_id
    const map = {}
    produtos.forEach(row => {
      if (map[row.product_id]) {
        map[row.product_id].qte_total += Number(row.qte_total)
        map[row.product_id].qte_separada += Number(row.qte_separada)
      } else {
        map[row.product_id] = {
          product_id: row.product_id,
          product_code: row.product_code,
          product_name: row.product_name,
          qte_total: Number(row.qte_total),
          qte_separada: Number(row.qte_separada),
        }
      }
    })
    return Object.values(map).map(row => ({
      ...row,
      percentual_separacao: row.qte_total ? (row.qte_separada / row.qte_total) * 100 : 0,
    }))
  }
  // consolidarLoteValidade = true: retornar os dados com lote e validade sem consolidar
  return produtos.map(row => ({
    ...row,
    qte_total: Number(row.qte_total),
    qte_separada: Number(row.qte_separada),
    percentual_separacao: Number(row.qte_total)
      ? (Number(row.qte_separada) / Number(row.qte_total)) * 100
      : 0,
  }))
}
